var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnmute = function SvgUnmute(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 85,
    height: 75,
    viewBox: "0 0 85 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 85,
    height: 75,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85 0H0v74.149h85V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131F20",
    fillOpacity: 0.6,
    d: "M84.962 34.251C84.213 13.346 70.137 1.703 49.421.27 24.423-1.471.968 9.044.038 36.409c-.378 11.047 2.2 23.049 11.368 30.249 8.38 6.587 19.81 7.506 30.11 7.483 25.747-.044 44.467-12.689 43.446-39.897"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.667 28.667 34 34h-5.333v8H34l6.667 5.333V28.667ZM51.426 28.573a13.333 13.333 0 0 1 0 18.854M46.72 33.28a6.667 6.667 0 0 1 0 9.427"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnmute);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHdpZHRoPSI4NSIgaGVpZ2h0PSI3NSIgIHZpZXdCb3g9IjAgMCA4NSA3NSI+CiAgPG1hc2sgaWQ9ImEiIHdpZHRoPSI4NSIgaGVpZ2h0PSI3NSIgeD0iMCIgeT0iMCIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgc3R5bGU9Im1hc2stdHlwZTpsdW1pbmFuY2UiPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTg1IDBIMHY3NC4xNDloODVWMFoiLz4KICA8L21hc2s+CiAgPGcgbWFzaz0idXJsKCNhKSI+CiAgICA8cGF0aCBmaWxsPSIjMTMxRjIwIiBmaWxsLW9wYWNpdHk9Ii42IiBkPSJNODQuOTYyIDM0LjI1MUM4NC4yMTMgMTMuMzQ2IDcwLjEzNyAxLjcwMyA0OS40MjEuMjcgMjQuNDIzLTEuNDcxLjk2OCA5LjA0NC4wMzggMzYuNDA5Yy0uMzc4IDExLjA0NyAyLjIgMjMuMDQ5IDExLjM2OCAzMC4yNDkgOC4zOCA2LjU4NyAxOS44MSA3LjUwNiAzMC4xMSA3LjQ4MyAyNS43NDctLjA0NCA0NC40NjctMTIuNjg5IDQzLjQ0Ni0zOS44OTciLz4KICA8L2c+CiAgPGcgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+CiAgICA8cGF0aCBkPSJNNDAuNjY3IDI4LjY2NyAzNCAzNGgtNS4zMzN2OEgzNGw2LjY2NyA1LjMzM1YyOC42NjdaTTUxLjQyNiAyOC41NzNhMTMuMzMzIDEzLjMzMyAwIDAgMSAwIDE4Ljg1NE00Ni43MiAzMy4yOGE2LjY2NyA2LjY2NyAwIDAgMSAwIDkuNDI3Ii8+CiAgPC9nPgo8L3N2Zz4=";